import { trustPilotBottom, trustPilotTop } from '../../../setup/settings/index';

type TruspilotProps =
    {
        type: number
    }
export default function TrustPilotManagement({ type }: TruspilotProps) {
    return (
        <>
            {type == 0 &&
                <div className="homeCategories__trustpilot">
                    <a href={trustPilotTop.href} target={trustPilotTop.openNewTab == true ? "_blank" : ""}>
                        <img src={trustPilotTop.imageUrl} />
                    </a>
                </div>
            }
            {type == 1 &&
                <div className="bigBannerBottom__trustpilot">
                    <a href={trustPilotBottom.href} target={trustPilotBottom.openNewTab == true ? "_blank" : ""}>
                        <img src={trustPilotBottom.imageUrl} />
                    </a>
                </div>

            }
        </>

    );
}